import type {
  KnowledgeDataFetchForTopicAction,
  KnowledgeDataFetchForTopicFailureAction,
  KnowledgeDataFetchForTopicPayload,
  KnowledgeDataFetchForTopicSuccessAction,
} from "entities/knowledgeData/actionTypes";
import { KnowledgeDataActionTypes } from "entities/knowledgeData/actionTypes";

export const fetchKnowledgeDataForTopic = (
  payload: KnowledgeDataFetchForTopicPayload,
  meta?: KnowledgeDataFetchForTopicAction["meta"],
): KnowledgeDataFetchForTopicAction => ({
  type: KnowledgeDataActionTypes.FETCH_FOR_TOPIC,
  meta: meta ?? { forceRefresh: false },
  payload,
});

export const fetchKnowledgeDataForTopicSuccess = (
  payload: KnowledgeDataFetchForTopicSuccessAction["payload"],
  meta: KnowledgeDataFetchForTopicSuccessAction["meta"],
): KnowledgeDataFetchForTopicSuccessAction => ({
  type: KnowledgeDataActionTypes.FETCH_FOR_TOPIC_SUCCESS,
  payload,
  meta,
});

export const fetchKnowledgeDataForTopicFailure = (
  meta: KnowledgeDataFetchForTopicFailureAction["meta"],
): KnowledgeDataFetchForTopicFailureAction => ({
  type: KnowledgeDataActionTypes.FETCH_FOR_TOPIC_FAILURE,
  meta,
});
